// extracted by mini-css-extract-plugin
module.exports = {"container":"aee5b7c44e--container--vP6aH","iframe":"aee5b7c44e--iframe--sr9P4","close":"aee5b7c44e--close--maGec","spinner":"aee5b7c44e--spinner--b23x9"};